import React, { useEffect, useState } from "react";
import Page1 from "./Page1";
import Page2 from "./Page2";
import Page3 from "./Page3";
import Page1Mobile from "./Page1Mobile";
import Page2Mobile from "./Page2Mobile";
import Page3Mobile from "./Page3Mobile";

const Landing = () => {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const sectionContainerStyle = {
    height: "100vh",
    width: "100vw",
    overflowY: "auto",
    scrollSnapType: "y mandatory",
    scrollBehavior: "smooth",
    position: "absolute",
    left: 0,
    top: 0,
  };

  const sectionContainerStyleMobile = {
    width: "100vw",
    overflowY: "auto",
    marginTop: "60px",
    position: "absolute",
    left: 0,
    top: 0,
  };
  const sectionStyle = {
    paddingInline: "8vw",
    height: "100vh",
    width: "100%",
    scrollSnapAlign: "center",
    position: "relative",
    overflow: "hidden",
  };

  const sectionStyleMobile = {
    paddingInline: "3.5vw",
    // height: "100vh",
    width: "100%",
    position: "relative",
    paddingTop: "50px",
  };

  return (
    <div
      style={
        isSmallScreen ? sectionContainerStyleMobile : sectionContainerStyle
      }
    >
      {isSmallScreen ? (
        <>
          <Page1Mobile sectionStyle={sectionStyleMobile} />
          <Page2Mobile sectionStyle={sectionStyleMobile} />
          <Page3Mobile sectionStyle={sectionStyleMobile} />
        </>
      ) : (
        <>
          <Page1 sectionStyle={sectionStyle} />
          <Page2 sectionStyle={sectionStyle} />
          <Page3 sectionStyle={sectionStyle} />
        </>
      )}
    </div>
  );
};

export default Landing;
